<template>
  <div class="info-card-container">
    <div class="card-title-container">
      <slot v-if="!hiddenIcon" name="icon">
        <i class="title-icon" :class="icon"></i>
      </slot>
      <span v-if="!hiddenTitle" class="title">{{ title || $t(titleI18nKey) }}</span>
      <div class="fit-container">
        <slot name="fitScore"></slot>
        <slot name="btnGroup"></slot>
      </div>
    </div>
    <div class="card-list">
      <div v-for="(info, index) in infoList" class="info-card info-line-list" :key="index">
        <slot name="infoLine">
          <template v-for="(line, lineName) in infoLines">
            <div v-if="!line.hidden" class="info-line" :key="lineName" :class="[line.fullLine && 'full-line', line.className]">
              <div class="info-label">
                <slot :name="line.labelSlotName" :label="line.label || $t(line.labelI18nKey)" :line="line">
                  {{ line.label || $t(line.labelI18nKey) }}
                </slot>
              </div>
              <div class="info-content" :class="[line.multipleText && 'multiple-text', line.bottomLine && 'bottom-line']">
                <slot :name="line.contentName">{{ getInfoContent(line, lineName, info) }}</slot>
              </div>
            </div>
          </template>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  components: {
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    single: {
      type: Boolean,
      default: false
    },
    infoList: {
      required: false
    },
    infoLines: {
      required: false
    },
    list: {
      type: Array,
      default: () => []
    },
    hiddenIcon: {
      type: Boolean,
      default: false
    },
    hiddenTitle: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    getInfoContent (line, lineName, info) {
      let value = info[lineName]
      if (line.dataKey) {
        value = _.get(info, line.dataKey)
      }
      if (line.formatter) {
        value = line.formatter(value, info)
      }
      return _.trim(value) || '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.info-card-container {
  .card-title-container {
    position: relative;

    .title-icon {
      font-size: 26px;
      color: #9a999b;
      vertical-align: middle;
    }

    .title {
      margin-left: 12px;
      line-height: 22px;
      font-size: 16px;
      font-weight: bold;
      vertical-align: middle;
      color: #303133;
    }

    .fit-container {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .card-list {
    .info-card {
      margin-top: 14px;
      padding: 24px 40px;
      background: #fff;
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.08);
    }

    .info-line-list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 16px;

      .info-line {
        width: 48%;
        line-height: 20px;

        &.full-line {
          width: 100%;
        }

        .info-label {
          color: #303133;
          font-weight: bold;
          position: relative;
        }

        .info-content {
          margin-top: 3px;
          color: #606266;

          &.multiple-text {
            white-space: pre-wrap;
          }
        }

        &:not(:last-child) {
          .info-content {
            &.bottom-line {
              padding-bottom: 16px;
              border-bottom: 1px solid #dcdfe6;
            }
          }
        }
      }
    }
  }
}
</style>
